export default "__VITE_ASSET__CSX6IilB__"